import React from 'react'
import Layout from '../Layout'

export default function termsOfService(props) {
    return (
        <Layout props={props}>
            <div className="px-5 py-4 stctPgWrpr">
                {/* <h2>About Us</h2> */}
                <span
                    dangerouslySetInnerHTML={{
                        __html: global.storeDetails.terms_condition,
                    }}
                ></span>
            </div>
        </Layout>
    )
}
